module.exports = __webpack_public_path__ + "static/media/bnr_nagi2c1b0e14063123e77c323432edf6e6a2.webp";